import FloatingSupport from '~/components/_core/ui/floating-support/index.vue';

export default {
  name       : 'FullscreenLayout',
  components : {
    FloatingSupport
  }
};
